import { useState } from 'react';
import WalletDropdownContent from '../WalletDropdownContent';
import WalletDropdownHeader from '../WalletDropdownHeader';

const WalletDropdownContainer = () => {
    const [renderSlippage, setRenderSlippage] = useState(false);

    return (
        <div className='wallet-dropdown-container'>
            <WalletDropdownHeader
                renderSlippage={renderSlippage}
                setRenderSlippage={setRenderSlippage}
            />
            <WalletDropdownContent
                renderSlippage={renderSlippage}
                setRenderSlippage={setRenderSlippage}
            />
        </div>
    );
};
export default WalletDropdownContainer;
